/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-05-25 09:17:44
 * @LastEditors: linxi
 * @LastEditTime: 2025-01-10 10:17:45
 */
import { notification, Table } from 'antd'
import { unwrapResult } from '@reduxjs/toolkit'
import React, { ReactElement, useEffect, useState, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EditableList } from '../../../compnents/list/EditableList'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { changeWaterParams } from '../../../services/changewater'
import {
  AGWaterColumns,
  waterListData,
  buildDynamicColumns,
  PrintChangeWaterColumns,
} from './columns'
import { ChangeWaterQuerys } from './Query'
import {
  getChangeWaterDetail,
  getChangeWaterList,
  selectChargeWatertData,
  selectCurrent,
  selectDetail,
  selectTotal,
  setCurrent,
  getChangeWaterExoprt,
  selectPageLoading,
  setPageLoading,
  selectChargeWatertSummaryData,
} from './changeWaterSlice'
import { getSortColumnList } from '../../../models/common'
import {
  getPageColumnListAsync,
  getSubmitPageColumnListAsync,
} from '../../transactionQuery/transactionQuerySlice'
import { ChargeWaterModel } from './Modal'
import styles from './charge.module.css'
import { RootDispatch } from '../../../app/store'

import { PrintFrame, PrintFrameRef } from '../../print/PrintFrame'

import { DoctorSaleEntry, DoctorSalesResult } from '../../../models/doctorSales'
import { TabBar, TabPane } from '../../../compnents/widgets/TabBar'
import { selectTenantName } from '../../../app/applicationSlice'
import { changeWaterPrintBody } from '../../../models/changeWaterPrint'
import { getStationOrderSourceNames } from '../../../models/changeWater'
import moment from 'moment'
import { DateTimeFormatSimple } from '../../../models/datetime'
export const ChargeWater = (props: { type?: string }): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [queries, setQueries] = useState<changeWaterParams>()

  const [SelectId, setSelectId] = useState(0)

  const Current = useSelector(selectCurrent)

  const total = useSelector(selectTotal)

  const data: any = useSelector(selectChargeWatertData)

  const summaryData = useSelector(selectChargeWatertSummaryData)

  const [size, setSize] = useState(10)

  const [isstate, setState] = useState()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [releasingTimeFlag, setReleasingTime] = useState(false)

  const printRef = useRef<PrintFrameRef>(null)

  const tenantName = useSelector(selectTenantName)

  const [result, setResult] = useState({
    headers: [],
    entries: [],
  } as DoctorSalesResult)

  const pageLoadingRX = useSelector(selectPageLoading)

  const [exportloading, setExportloading] = useState(false)

  // ============ 列显示/拖拽配置（与交易查询一致，持久化到后端 tablefieldconfig） ============
  const allData = waterListData

  // 后端保存的列配置（静态 + 动态），初始为空
  const [configData, setConfigData] = useState<any[]>([])

  // 当次数据生成的动态支付列（默认可见，随数据变化）
  const dynColumns = useMemo(() => buildDynamicColumns(data), [data])

  // 合成最终列配置：静态列（后端/默认 + 宽高表头回填）+ 动态列（顺序/显隐回放自后端配置）
  const allColumnList = useMemo(() => {
    const staticConfig = (configData || [])?.filter((c: any) => !c?.dynamic)
    const resetStatic: any[] = (staticConfig?.length
      ? staticConfig
      : allData
    )?.map((v: any) => {
      const sameFileds = allData?.find((item: any) => item?.field == v?.field)
      return {
        ...v,
        minWidth: sameFileds?.minWidth || v?.minWidth,
        width: sameFileds?.width || v?.width,
        headerName: sameFileds?.headerName || v?.headerName,
      }
    })
    // 回放后端配置中动态列的显隐/顺序
    const dynConfigList =
      (configData || [])?.filter((c: any) => c?.dynamic) || []
    const dynVisibleMap: any = {}
    dynConfigList?.forEach((c: any) => {
      dynVisibleMap[c.field] = c.visible
    })
    const mergedDyn = [...(dynColumns || [])]
      ?.sort((a: any, b: any) => {
        const ia = dynConfigList?.findIndex((c: any) => c.field == a.field)
        const ib = dynConfigList?.findIndex((c: any) => c.field == b.field)
        if (ia == -1 && ib == -1) return 0
        if (ia == -1) return 1
        if (ib == -1) return -1
        return ia - ib
      })
      ?.map((c: any) =>
        dynVisibleMap[c.field] === undefined
          ? c
          : { ...c, visible: dynVisibleMap[c.field] }
      )
    // 动态列插入到「总金额」之前，保持原表格列顺序
    const merged: any[] = [...(resetStatic || [])]
    const insertIdx = merged?.findIndex((v: any) => v.field === 'totalPayAmount')
    if (insertIdx > -1) {
      merged?.splice(insertIdx, 0, ...(mergedDyn || []))
    } else {
      merged?.push(...(mergedDyn || []))
    }
    return merged
  }, [configData, data])

  // 当前显示的字段（由列配置的 visible 派生）
  const filterSelectList =
    allColumnList?.filter((v: any) => v.visible)?.map((v: any) => v.field) || []

  useEffect(() => {
    if (queries?.timeHead) {
      dispatch(setPageLoading(true))
      getPageColumnList()
      dispatch(getChangeWaterList({ ...queries, current: Current, size }))
      setTimeout(() => {
        dispatch(setPageLoading(false))
      }, 3000)
    }
  }, [Current, size, queries])

  // 保存列配置（显隐/顺序）到后端，成功后重新拉取
  const submitPageList = (data: any) => {
    const params = {
      pageName: 'shoufeiliushui',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  // 获取后端保存的列配置，仅保存原始配置，由 useMemo 合成最终列
  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'shoufeiliushui',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        setConfigData(data || [])
      })
      .catch(() => {
        setConfigData([])
      })
  }

  const table = () => (
    <div id='tableHeightChangeWater' style={{ width: '100%', height: '100%', overflowY: 'hidden' }}>
      <SimpleAgGrid
        page={{
          items: data,
          current: Current,
          size: size,
          total: total,
        }}
        column={AGWaterColumns(
          size * (Current - 1),
          (id: any, t: any, state: any) => {
            if (t == '查看详情') {
              dispatch(getChangeWaterDetail(id))
              setIsModalVisible(true)
              setState(state)
            } else {
              return
            }
          },
          allColumnList
        )?.filter((item: any) => filterSelectList?.includes(item.field))}
        isLoading={pageLoadingRX}
        pagination={true}
        pageKey={'changeWater'}
        onRowDoubleClick={(event: any) => {
          const d = event.data
          setState(d.state)
          dispatch(getChangeWaterDetail(d.id))
          setIsModalVisible(true)
        }}
        pinnedBottomRowData={[bottomRowData]}
        suppressRowClickSelection={true}
        getRowStyle={(params: any) => {
          if (params.node.rowPinned) {
            return {
              fontWeight: 'normal',
              backgroundColor: '#D9F2FF',
            }
          }
          return {}
        }}
        onChangePage={(current, pageSize) => {
          setSize(pageSize as number)
          dispatch(setCurrent(current))
        }}
        onColumnResized={() => {
          return
        }}
        onColumnMoved={(v) => {
          const sortList = getSortColumnList(allColumnList, v)
          submitPageList(sortList)
          setConfigData(sortList)
        }}
      />
    </div>
  )
  const outCluedExport = () => {
    setExportloading(true)
    dispatch(
      getChangeWaterExoprt({
        ...queries,
        current: Current,
        size,
        pageName: 'shoufeiliushui',
        releasingTime: releasingTimeFlag ? '99' : undefined,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '收费流水.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setExportloading(false)
      })
  }

  const titleList = data?.[0]?.customizePay?.map((v: any) => {
    return { payMethodName: v?.payMethodName, payMethod: v?.payMethod }
  })

  // 动态合计行
  const groupByName = (arr: any) => {
    const groupedData: any = {}
    // 遍历原始数组
    arr?.forEach(function (item: any) {
      // 同时根据payMethodName和itemIndex进行分组
      const key = `${item.payMethodName}_${item.itemIndex}`
      // 如果组合键在 groupedData 中不存在，创建一个新数组
      if (!groupedData[key]) {
        groupedData[key] = []
      }
      // 将当前项添加到对应组合键的数组中
      groupedData[key].push(item)
    })
    // 将结果从对象转换为数组
    const result = Object.values(groupedData)
    return result
  }

  const totalPageList: any = groupByName(
    data
      ?.map((v: any) => {
        return v?.customizePay?.map((item: any,itemIndex:number) => {
          return {...item,itemIndex:itemIndex}
        })
      })
      ?.flat(2)
  )
    ?.map((paymentMethod: any) => {
      const payMethodName = paymentMethod[0].payMethodName
      const itemIndex = paymentMethod[0].itemIndex
      const totalValue = paymentMethod.reduce(
        (total: any, payment: any) =>
          Number(total) + Number(payment.payMethodAmount),
        0
      )
      return { payMethodName, itemIndex, totalValue }
    })
    ?.sort((a: any, b: any) => a.payMethodName?.localeCompare(b.payMethodName))

  // AG Grid 底部合计行：动态支付列合计 + 静态金额列合计（字段与列 field 对应）
  const bottomRowData: any = {
    patientName: '合计',
    ...((totalPageList || [])?.reduce((acc: any, v: any) => {
      acc['otherPay_' + v?.payMethodName + '_' + v?.itemIndex] = Number(
        v?.totalValue
      )?.toFixed(2)
      return acc
    }, {}) || {}),
    totalPayAmount: summaryData?.totalPayAmountSUM,
    shouldPayAmount: summaryData?.shouldPayAmountSUM,
    realPayAmount: summaryData?.realPayAmountSUM,
  }

  const dataMainList = {
    tenantName: tenantName?.split('-')?.[0],
    dataList: data?.map((v: any) => {
      return {
        ...v,
        outpatientNo: v.outpatientNo == -1 ? '' : v.outpatientNo,
        registrationCategory:
          v?.registrationCategory == 0
            ? '自费'
            : v?.registrationCategory === -1
            ? ' -'
            : '医保',
        orderSource: getStationOrderSourceNames(v.orderSource),
        shouldPayAmount: Number(v?.shouldPayAmount)?.toFixed(2),
        realPayAmount: Number(v?.realPayAmount)?.toFixed(2),
        createTime: v.createTime
          ? moment(v.createTime)?.format(DateTimeFormatSimple)
          : '-',
      }
    }),
    // timeHead: moment(queries?.timeHead).format(DateTimeFormatSimpleOnly),
    // timeTail: moment(queries?.timeTail).format(DateTimeFormatSimpleOnly),
    titleList: titleList,
    totalPageList: totalPageList,
    summaryData: summaryData,
  }

  const content = changeWaterPrintBody(dataMainList)

  return (
    <>
      {props?.type != '1' ? (
        <TabBar style={{ margin: '10px 20px' }}>
          <TabPane key='0' tab='收费流水'>
            <div className={styles.content}>
              <ChangeWaterQuerys
                type={props?.type}
                loading={pageLoadingRX}
                exportloading={exportloading}
                onValueChange={(v) => {
                  setQueries({ ...queries, ...v })
                  dispatch(setCurrent(1))
                }}
                print={() => {
                  // printRef.current?.print()
                  const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
                  page.document.write(content) // 写入打印页面的内容
                  page.print() // 打印
                  page?.close()
                }}
                outClued={() => {
                  outCluedExport()
                }}
                alertMessage={() => {
                  alert('Service mode is open')
                  setReleasingTime(true)
                }}
                filterColumn={allColumnList} //筛选列
                filterSelectList={filterSelectList}
                // 筛选列变化时的数据
                submitPageList={(v: any) => {
                  submitPageList(v)
                  setConfigData(v)
                }}
              />
              {table()}
            </div>
          </TabPane>
        </TabBar>
      ) : (
        <div className={styles.contents}>
          <ChangeWaterQuerys
            type={props?.type}
            loading={pageLoadingRX}
            exportloading={exportloading}
            onValueChange={(v) => {
              setQueries({ ...queries, ...v })
              dispatch(setCurrent(1))
            }}
            print={() => {
              // printRef.current?.print()
              const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
              page.document.write(content) // 写入打印页面的内容
              page.print() // 打印
              page?.close()
            }}
            outClued={() => {
              outCluedExport()
            }}
            filterColumn={allColumnList} //筛选列
            filterSelectList={filterSelectList}
            // 筛选列变化时的数据
            submitPageList={(v: any) => {
              submitPageList(v)
              setConfigData(v)
            }}
          />
          {table()}
        </div>
      )}
      <ChargeWaterModel
        isModalVisible={isModalVisible}
        state={isstate}
        onOk={() => {
          setIsModalVisible(false)
          setSelectId(0)
        }}
        onCancel={() => {
          setIsModalVisible(false)
          setSelectId(0)
        }}
      />
      <PrintFrame
        ref={printRef}
        title={
          JSON.parse(localStorage.getItem('credentials') as string)?.tenantName
        }
        subTitle='收费流水'
      >
        <EditableList
          className={styles.charges}
          rowKey={(t: any) => t.id}
          page={{
            items: data,
            current: Current,
            size: size,
            total: total,
          }}
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row className={styles.total}>
                <Table.Summary.Cell
                  index={0}
                  align='center'
                ></Table.Summary.Cell>
                <Table.Summary.Cell index={1} align='center'>
                  合计
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2}></Table.Summary.Cell>
                <Table.Summary.Cell index={3}></Table.Summary.Cell>
                <Table.Summary.Cell index={4}></Table.Summary.Cell>
                <Table.Summary.Cell index={5} align='right'>
                  {summaryData?.shouldPayAmountSUM}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} align='right'>
                  {summaryData?.realPayAmountSUM}
                </Table.Summary.Cell>

                <Table.Summary.Cell index={7}></Table.Summary.Cell>
                <Table.Summary.Cell index={8}></Table.Summary.Cell>
                <Table.Summary.Cell index={9}></Table.Summary.Cell>
                <Table.Summary.Cell index={10}></Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
          pagination={false}
          columns={PrintChangeWaterColumns((id: any, t: any, state: any) => {
            if (t == '查看详情') {
              dispatch(getChangeWaterDetail(id))
              setIsModalVisible(true)
              setState(state)
            } else {
              return
            }
          }, size * (Current - 1))}
          onRow={(d: any) => ({
            onDoubleClick: () => {
              setState(d.state)
              dispatch(getChangeWaterDetail(d.id))
              setIsModalVisible(true)
            },
          })}
          onChangePage={(current, pageSize) => {
            setSize(pageSize as number)
            dispatch(setCurrent(current))
          }}
        />
      </PrintFrame>
    </>
  )
}
